<template>
    <v-container>
        <vs-card style="display: block;
                        margin: auto;
                        min-width: 350px;
                        max-width: 400px;
                        margin-top: 8%;
                        border-radius: 10px;">
            <div>
                <div class="p-2">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-12">
                                <a href="/login" class="logo logo-admin">
                                    <img src="https://www.ausa.com.mx/img/Ausa-logov5.png" height="80" alt="logo"
                                         style="margin: auto; max-width: 200px !important;" />
                                </a>
                            </div>
                            <div class="col-md-12" style="top:30px;">
                                <h4 class="login-title-text" style="text-align:center;">Recuperar Contraseña</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-2">
                    <form @submit.prevent="Recuperar()" class="form-horizontal m-t-20" autocomplete="off">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12 col-sm-12">
                                    <div class="form-group row">
                                        <vs-input style="width:300px;" :danger="errors.has('username')"
                                                  :danger-text="errors.has('username') ? errors.first('username') : ''"
                                                  name="username" data-vv-as="usuario" v-validate="'required|max:16'" type="text"
                                                  label-placeholder="Usuario" v-model.trim="user.username" />
                                    </div>
                                </div>
                                <br>
                                <div class="col-md-6 col-sm-12" style="left:4px;">
                                </div>

                            </div>
                        </div>
                        <div>
                            <vs-alert color="danger" v-if="ver">
                                <span style="width: 90%;">{{ mensaje }}</span>
                            </vs-alert>
                        </div>

                        <div class="form-group text-center row m-t-20">
                            <div class="col-12">
                                <br>
                                <button class="vs-button-primary vs-button-filled btn-block vs-button"
                                        :disabled="user.username && !loggedIn ? false : true">
                                    <span v-show="!loggedIn">Aceptar</span>
                                    <div v-show="loggedIn" class="spinner-border spinner-border-sm" role="status">
                                        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                                             xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                                    stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor"
                                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                            </path>
                                        </svg>
                                        Procesando
                                    </div>
                                </button>
                                <vs-button color="danger" type="filled" @click="regresar()" class="ml-1">Regresar</vs-button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </vs-card>
    </v-container>
</template>

<script>

import loginService from "../services/login/login.service";
import { mapState } from "vuex";

export default {
    data() {
        return {
            loggedIn: false,
            user: {
                username: "",
                password: ""
            },
            mensaje: "",
            ver: false,
        }
    },
    computed: {
        ...mapState(["domain", 'informationPage'])
    },
        methods: {
            regresar() {
                window.history.back();
            },
        async Recuperar() {
            this.loggedIn = true;
            this.ver = false;
            let formdata = new FormData();
            formdata.append("username", this.user.username);
            await loginService.BloqueRecuperar(formdata).then(data => {
                if (data[0].success == 'true') {
                    loginService.IntentosRecuperarPass(this, formdata).then(data => {
                        if (data[0].success == 'false') {
                            this.mensaje = data[0].mensaje;
                        }
                        else {
                            this.mensaje = data[0].mensaje;
                        }
                        this.loggedIn = false;
                        if (this.mensaje != '') {
                            this.ver = true;
                            this.ver = false;
                            this.ver = true;
                        }
                    });
                }
                else {
                    this.loggedIn = false;
                    this.mensaje = 'Acceso denegado';
                    this.ver = true;
                    this.ver = false;
                    this.ver = true;
                }
                //
            });



        }
    }
}
</script>
<style scoped>
    .login-title-text {
        font-family: "Poppins", sans-serif;
        font-size: 18px;
        font-weight: 900;
        margin-bottom: 0px;
        color: #757575 !important;
    }
</style>